package tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class JoinQueueData(
    @SerialName("queue_position")val queuePosition:String? = null
)
